import Modal from "react-bootstrap/Modal";
import "../style/rightside.css";
import share from "../asset/images/flex/share.svg";
import deletes from "../asset/images/flex/deletes.svg";
import RecordPayment from "./Recordpayment";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import currencyPairCheck from "../utilities/currencyPairCheck";
import AmountCheck from "./amountCheck";
import { isSender } from "./flex/utils";

function InvoiceDetails(props) {
    const [show, setshow] = useState();
    const [_, seteachinvoice] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [invoices, setinvoices] = useState([]);
    const selectorBusiness = useSelector((state) => state.business);
    const selector = useSelector((state) => state.users);
    const isActiveSender = isSender(selectorBusiness?._id, invoiceDetails?.business?._id);

    useEffect(() => {
        const fetchinoice = async () => {
            await axios
                .get(`/v1/invoice/${props?.selecteditem._id}`)
                .then((res) => {
                    setInvoiceDetails(res.data.data);
                    seteachinvoice(res.data.data.invoiceItems);
                    setinvoices(res.data.data.recordPayments);
                })
                .catch((e) => {
                    console.log(e);
                });
        };
        if (props?.selecteditem?._id) {
            fetchinoice();
        }
    }, [props.selecteditem._id, seteachinvoice]);

    const navigate = useNavigate();
    return (
        <>
            <RecordPayment
                show={show}
                setshow={setshow}
                selectedinvoice={props.selecteditem}
                record={invoices}
                setinvoices={setinvoices}
                currency={props.selecteditem.currency}
            />
            <Modal
                show={props.show}
                backdrop="false"
                onHide={() => props.setshow(false)}
                keyboard={false}
                className=" mysidedetail"
            >
                <div className="relative flex items-center justify-center h-full">
                    <div className="h-[calc(100%-150px)] w-full p-3">
                        <div className="w-full h-full mt-10">
                            <div className="relative flex flex-col w-full gap-4">
                                {props.deletes && (
                                    <div className="bg-[#FCFCFD] border border-[#D0D5DD]">
                                        <div className="lg-success">
                                            <div className="ech-lg-hm bg-[#F9FAFB]">
                                                <div className="main-sucees text-[#344054]">
                                                    Deleted
                                                </div>
                                                <span className="text-[#344054]">
                                                    You’ve deleted an invoice
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div
                                    className="flex items-center gap-3 cursor-pointer"
                                    onClick={() => {
                                        props.setshow(false);
                                    }}
                                >
                                    <span className="material-icons text-[#667085]">
                                        arrow_back
                                    </span>
                                    <span className="text-sm text-[#667085] leading-[18.9px] font-medium uppercase">
                                        back to pay
                                    </span>
                                </div>

                                <div className="text-2xl leading-[40px] font-medium text-[#101828]">
                                    {props.selecteditem.invoiceTitle}
                                </div>
                            </div>

                            <div className="flex flex-col gap-8 mt-8">
                                <div className="border border-[#E7E9FB] max-w-[90%] rounded-lg w-full p-4 flex flex-col gap-6">
                                    <div className="flex flex-col gap-1">
                                        <span className="text-[#6F00FF] font-medium text-sm leading-[19.6px]">
                                            Amount due
                                        </span>
                                        <span className="text-[#101828] font-medium text-2xl leading-[32.4px]">
                                            {currencyPairCheck(props.selecteditem.currency)}
                                            {AmountCheck(
                                                props.selecteditem?.totalAmount
                                                    ? props.selecteditem?.totalAmount
                                                    : 0
                                            )}
                                        </span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div className="flex flex-col gap-1">
                                            <span className="text-[#667085] font-medium text-sm leading-[19.6px]">
                                                Issue date
                                            </span>
                                            <span className="text-[#101828] font-medium text-sm leading-[19.6px]">
                                                {new Date(
                                                    props.selecteditem.issueDate
                                                ).toDateString()}
                                            </span>
                                        </div>
                                        <div className="flex flex-col gap-1">
                                            <span className="text-[#667085] font-medium text-sm leading-[19.6px]">
                                                Due date
                                            </span>
                                            <span className="text-[#101828] font-medium text-sm leading-[19.6px]">
                                                {new Date(
                                                    props.selecteditem.dueDate
                                                ).toDateString()}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="flex flex-col w-full max-w-full gap-2">
                                        <label
                                            htmlFor="Invoice"
                                            className="text-[#344054] font-medium text-sm leading-[19.6px]"
                                        >
                                            Payment Link
                                        </label>
                                        <div className="flex items-center gap-2 bg-[#F4F0FF] p-2 pl-4 rounded-md relative min-h-[44px]">
                                            <span className="text-[#6F00FF] text-sm leading-[19.6px] font-normal cursor-pointer">
                                                <a
                                                    className="text-[#6F00FF] text-sm leading-[19.6px] font-medium cursor-pointer no-underline"
                                                    href={props.selecteditem.paymentLink}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {props.selecteditem.paymentLink}
                                                </a>
                                            </span>

                                            <span
                                                onClick={() =>
                                                    navigate("/flex/shareInvoice", {
                                                        state: {
                                                            ...props.selecteditem,
                                                        },
                                                    })
                                                }
                                                className="text-[#5E01D6] text-sm font-medium bg-[#D9CDFF] rounded-[4px] py-[4px] px-[8px] absolute right-[8px] z-[9999] cursor-pointer"
                                            >
                                                share
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-t border-[#E7E9FB] max-w-[90%] w-full flex py-[8px] gap-[16px] items-center border-b border-[#E7E9FB]">
                                    <div
                                        className="flex gap-[4px] p-[8px]"
                                        onClick={() =>
                                            navigate("/flex/shareInvoice", {
                                                state: {
                                                    ...props.selecteditem,
                                                },
                                            })
                                        }
                                    >
                                        <img src={share} alt="" />
                                        <span className="text-[#6F00FF] font-medium text-[14px] leading-[19.6px] cursor-pointer">
                                            Share
                                        </span>
                                    </div>

                                    <div
                                        className="flex gap-1 p-2"
                                        onClick={() => props.setshow3(true)}
                                    >
                                        <img src={deletes} alt="" />
                                        <span className="text-[#D92D20] font-medium text-sm leading-[19.6px] cursor-pointer">
                                            Delete
                                        </span>
                                    </div>
                                    <div></div>
                                </div>
                                {isActiveSender ? (
                                    <>
                                        <div className="flex flex-col gap-2.5 max-w-[90%] w-full">
                                            <label
                                                htmlFor="Invoice"
                                                className="text-[#344054] font-medium text-sm leading-5"
                                            >
                                                Bill To
                                            </label>

                                            <div className="flex flex-col gap-2">
                                                <div className="flex items-center justify-between border border-[#E7E9FB] rounded-lg p-4 cursor-pointer">
                                                    <div className="flex gap-2">
                                                        <div className="intial">
                                                            {props?.selecteditem?.firstName?.slice(
                                                                0,
                                                                1
                                                            )}
                                                            {props?.selecteditem?.lastName?.slice(
                                                                0,
                                                                1
                                                            )}
                                                        </div>
                                                        <div className="flex flex-col gap-1">
                                                            <span className="text-[#101828] font-medium text-sm leading-[19.6px]">
                                                                {props?.selecteditem?.businessName}
                                                            </span>
                                                            <span className="text-[#667085] tracking-[2%] font-medium leading-[16.2px]">
                                                                {props?.selecteditem?.email}.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="flex flex-col gap-2 max-w-[90%] w-full">
                                            <label
                                                htmlFor="Invoice"
                                                className="text-[#344054] font-medium text-sm leading-[19.6px]"
                                            >
                                                Bill From
                                            </label>
                                            <div className="flex flex-col gap-2">
                                                <div className="border border-[#E7E9FB] rounded-lg p-4 flex items-center justify-between cursor-pointer">
                                                    <div className="flex gap-2">
                                                        <div className="intial">
                                                            {selector?.firstName?.slice(0, 1)}
                                                            {selector?.lastName?.slice(0, 1)}
                                                        </div>
                                                        <div className="flex flex-col gap-1">
                                                            <span className="text-[#101828] font-medium text-sm leading-[19.6px]">
                                                                {selector?.firstName}{" "}
                                                                {selector?.lastName}
                                                            </span>
                                                            <span className="text-[#667085] tracking-[2%] font-medium leading-[16.2px]">
                                                                {selectorBusiness?.name}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className="flex flex-col gap-2 max-w-[90%] w-full">
                                    <label
                                        htmlFor="Invoice"
                                        className="text-[#344054] font-medium text-sm leading-[19.6px]"
                                    >
                                        Invoice Items
                                    </label>
                                    <div className="flex flex-col gap-2">
                                        {props?.selecteditem?.invoiceItems?.map((item, index) => (
                                            <div
                                                key={index}
                                                className="flex justify-between border border-[#E7E9FB] p-2 rounded-lg"
                                            >
                                                <div className="flex flex-col gap-2">
                                                    <span className="text-[#101828] text-base leading-6 tracking-[2%] font-normal">
                                                        {item.itemName}
                                                    </span>
                                                    <span className="text-[#667085] font-normal text-sm leading-[19.6px]">
                                                        Quantity {item.quantity}, Unit Price{" "}
                                                        <span className="text-[#667085] font-normal text-sm leading-[19.6px]">
                                                            {currencyPairCheck(
                                                                props.selecteditem.currency
                                                            )}
                                                            {AmountCheck(item.pricePerUnit)}
                                                        </span>
                                                    </span>
                                                </div>
                                                <span className="text-[#101828] text-base leading-6 tracking-[2%]">
                                                    {currencyPairCheck(props.selecteditem.currency)}
                                                    {AmountCheck(
                                                        item.pricePerUnit * item.quantity +
                                                            props.selecteditem.surCharge +
                                                            props.selecteditem.vat
                                                    )}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="flex flex-col gap-4 max-w-[90%] w-full">
                                    {invoices.length === 0 && (
                                        <label
                                            htmlFor="Recorded payments"
                                            className="text-[#344054] font-medium text-sm leading-[19.6px]"
                                        >
                                            No recorded payment
                                        </label>
                                    )}
                                    <div className="max-h-[508px] min-h-[150px] border border-[#E7E9FB] p-4 pb-0 rounded-lg leading-6 overflow-auto relative">
                                        {invoices.length === 0 && (
                                            <div className="no-record">No recorded payment</div>
                                        )}

                                        {invoices?.map((res, index) => (
                                            <div
                                                key={index}
                                                className="border-b border-[#E7E9FB] py-2"
                                            >
                                                <div className="flex flex-col gap-2">
                                                    <span className="text-[#101828] text-sm leading-[19.6px] font-normal">
                                                        You recorded{" "}
                                                        {currencyPairCheck(res.currency)}
                                                        {AmountCheck(res.amount)} for this invoice.
                                                    </span>
                                                    <span className="text-[#667085] leading-[16.2px] font-normal text-xs tracking-[2%]">
                                                        {new Date(res.paymentDate).toDateString()}{" "}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}

                                        <button
                                            className="max-w-[208px] ml-auto p-4 rounded-lg bg-[#EBE4FF] text-[#6F00FF] font-bold text-base tracking-[1%] leading-6 outline-none border-0 w-full shadow-md mt-2 mb-1"
                                            onClick={() => {
                                                setshow(true);
                                            }}
                                        >
                                            Record payment
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default InvoiceDetails;
